import React from 'react';
import { GIFTCARD_BALANCE_ROUTE } from '../../../../constants/Routes';
import GiftcardIcon from '../../../common/icons/GiftcardIcon';

export const giftCardBalanceGroup = [
  {
    route: GIFTCARD_BALANCE_ROUTE,
    icon: <GiftcardIcon size="30px" />,
    title: 'Saldos gift card',
    id: 'giftCardBalanceSection',
  },
];
